import React from 'react';
import { Portal, Tooltip, defaultStyles } from '@visx/tooltip';

const tooltipStyles = {
  ...defaultStyles,
  minWidth: '4vw',
  backgroundColor: 'rgba(0,0,0,0.7)',
  color: 'white',
  fontSize: '.8vw',
  fontFamily: 'Roboto',
  transform: 'translate(-50%, -100%)',
  zIndex: 4200,
};

const TooltipWrapper = function TooltipWrapper({
  children,
  open,
  data,
  tooltipPosition,
  portal = false,
}) {
  const TooltipComponent = (
    <Tooltip
      top={tooltipPosition.top - 10}
      left={tooltipPosition.left}
      style={tooltipStyles}
    >
      <div style={{ position: 'relative' }}>{children}</div>
    </Tooltip>
  );
  return (
    open &&
    data && (
      <>{portal ? <Portal>{TooltipComponent}</Portal> : TooltipComponent}</>
    )
  );
};

export default TooltipWrapper;
